
import React from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { tableEditIcon } from "../../../assets/images";
import { DepartmentListType } from "../../../redux/clientSettings/clientSettingTypes";
import UpdatedByAndUpdatedAt from "../../commons/CommonUpdatedByAndUpdatedAt";
import { formateDateTime } from "../../../utils/commonFunctions";

type AppProps = {
  tableHeaders: TableHeadersType[] | [];
  data: DepartmentListType[] | [];
  handleEditDepartment:(data:DepartmentListType)=>void
};

const DepartmentTableData = ({ tableHeaders, data ,handleEditDepartment}: AppProps) => {
  return (
    
    <>
      {data?.length > 0 &&
        data?.map((departmentData: DepartmentListType) => {
          return (
            <tr className="text-left">
              {tableHeaders?.length > 0 &&
                tableHeaders?.map((header: TableHeadersType) => {
                  if (header?.value == "department_name") {
                    return (
                      <td className="text-left" style={{width:'350px'}}>
                        {departmentData?.department_name}
                      </td>
                    );
                  } 
                  else if (header?.value === "updated_by") {
                    return (
                      <td style={{width:'180px'}}>
                         <UpdatedByAndUpdatedAt
                          firstName={departmentData?.updated_by?.first_name ? departmentData?.updated_by?.first_name:''}
                          lastName={departmentData?.updated_by?.last_name ? departmentData?.updated_by?.last_name :""}
                          profilePic={departmentData?.updated_by?.profile_pic?.file_url}
                          updatedAt={departmentData?.updated_at?formateDateTime(departmentData?.updated_at):''}
              />
                        
                      </td>
                    );
                  }
                  else if (header?.value == "status") {
                    return (
                      <td className="text-left">
                        {departmentData?.status === 1
                          ? "Active"
                          : "Inactive"}
                      </td>
                    );
                  } else if (header?.value == "Edit") {
                    return (
                      <td style={{ maxWidth: '120px' , textAlign: "start" }}>
                        <span  className="d-inline-block pointer" onClick={()=>handleEditDepartment(departmentData)}> 
                          <div
                            style={{
                              color: "#d43",
                              fontSize: 20,
                            }}
                          >
                            {/* <i className="fas fa-pen"></i> */}
                            <img src={tableEditIcon}alt ="edit"/>

                          </div>
                        </span>
                      </td>
                    );
                  }
                  return null;
                })}
            </tr>
          );
        })}
    </>
  );
};

export default DepartmentTableData;

